export default __webpack_public_path__ + "static/media/BeaconLogoFull.e890eba5.svg";